import { useTranslation } from 'react-i18next';
import fieldIcon from '../../../../assets/icons/field_icon.svg';
import vcIcon from '../../../../assets/icons/vc_icon.svg';
import {StyledCard, StyledCardDiv, FieldIconContainer, TextContainer, Title, Subtitle, SubTitleOne, SubTitleTwo, StyledValueOne} from './styles/vaStyles';
import { getVCLabel, getIndexValue } from './helper/vaHelper';

const FieldVariabilityCard = ({
  data,
  handleFieldClick,
  selectedFieldData
}: {
  data: any;
  handleFieldClick:any,
  selectedFieldData:any
}) => {
  const [t] = useTranslation();

  return (
    <StyledCardDiv>
      <StyledCard
        role='button'
        tabIndex={0}
        key={data.id}
        id={data.id}
        className={`field-card ${selectedFieldData && selectedFieldData.id === data.id ? 'selected-card' : ''}`}
        onClick={(e:any) => {
          handleFieldClick(data, e);
        }}
      >
        <FieldIconContainer>
          <img src={fieldIcon} alt='field logo' />
        </FieldIconContainer>
        <TextContainer>
          <Title>{data.name}</Title>
          <Subtitle>
            <SubTitleOne>
              <img src={vcIcon} alt='vc logo' />
              <span>{t('Variability Index')}:</span>
            </SubTitleOne>
            <SubTitleTwo>
              {Object.values(data.variability_index).length > 0 ? (
                <>
                  {getVCLabel(getIndexValue(data.variability_index.vxc), t)}
                  <StyledValueOne>{getIndexValue(data.variability_index.vxc)}</StyledValueOne>
                </>
              ) : (
                <StyledValueOne>N/A</StyledValueOne>
              )}
            </SubTitleTwo>
          </Subtitle>
        </TextContainer>
      </StyledCard>
    </StyledCardDiv>
  );
};

export default FieldVariabilityCard;
